import React from 'react';
import {Atom, Plugins, withSystem} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceCheckoutLabel = Atom.createRender((props) => {
  const {attributes, classes, data, generateAttributes, renderChild} = props;

  return (
    // TODO: fix jsx-a11y lint error
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </label>
  );
});

const config = createIntegratedAtom({
  displayName: 'Field Label',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(8),
        },
      },
    },
  },
  render: CommerceCheckoutLabel,
  fields: {
    attr: withSystem(
      {private: true},
      TRecord({
        for: TText,
      })
    ),
    children: TListOfElement,
  },
});

export default config;
